import React from 'react';
import { PurchaseWrapper, HeaderTypography, StyledMenuLine } from '../../../../Shared/Account/PurchaseWrapper.styles';
import PostSaleCard from '../PostSaleCard';

export default function PostSale() {
  return (
    <>
      <PurchaseWrapper>
        <HeaderTypography>Your Recent Purchase</HeaderTypography>
        <PostSaleCard />
      </PurchaseWrapper>
      <StyledMenuLine />
    </>
  );
}
